import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UserState {
  member_name: string;
  member_id: string;
  member_permit_level: number;
};

interface MemberState {
  memberName: string;
  memberId: string;
  memberPermitLevel: number;
  setMember: (user: UserState) => void;
};

export const useMemberStore = create<MemberState>()(
  persist(
    (set) => ({
      memberName: "",
      memberId: "",
      memberPermitLevel: 0,
      setMember: (user: UserState) =>
        set({
          memberName: user.member_name,
          memberId: user.member_id,
          memberPermitLevel: user.member_permit_level,
        }),
    }),
    {
      name: "member-storage",
    }
  )
);